var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.63623 15C12.5022 15 15.6362 11.866 15.6362 8C15.6362 4.13401 12.5022 1 8.63623 1C4.77024 1 1.63623 4.13401 1.63623 8C1.63623 11.866 4.77024 15 8.63623 15Z",
    stroke: "#C50631",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63623 5V9",
    stroke: "#C50631",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6362 11C8.46667 11 8.30095 11.0503 8.15999 11.1445C8.01904 11.2386 7.90917 11.3725 7.8443 11.5291C7.77942 11.6858 7.76245 11.8581 7.79552 12.0244C7.8286 12.1906 7.91023 12.3434 8.0301 12.4632C8.14998 12.5831 8.30271 12.6647 8.46898 12.6978C8.63525 12.7309 8.80759 12.7139 8.96421 12.649C9.12083 12.5842 9.2547 12.4743 9.34888 12.3333C9.44307 12.1924 9.49334 12.0267 9.49334 11.8571C9.49038 11.6307 9.39912 11.4144 9.23901 11.2543C9.07891 11.0942 8.8626 11.003 8.6362 11Z",
    fill: "#C50631"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorRed);
export default __webpack_public_path__ + "static/media/errorRed.de106b001416da2309438bdfdeedf782.svg";
export { ForwardRef as ReactComponent };